import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick';
import { productSliderList } from '../../data/localData';
import { BiCheckShield } from 'react-icons/bi';

function ProductSlider() {

    const [activeSlide, setActiveSlide] = useState(1);

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        waitForAnimate: false,
        beforeChange: (current, next) => {
            setActiveSlide(next + 1)
        },
        autoplay: true,
        autoplaySpeed: 2500,
        // afterChange: current => {
        //     console.log("current::", current);
        // }
    };

    return (
        <div className='home-gap home-product-slider'>
            <Container>
                <h1 className='fw-semibold fs-md-25 fs-sm-20 text-center m-0' data-aos="zoom-in">Paper cups for all your needs</h1>
                <Row>
                    <Col className='col-12'>
                        <div>
                            <div className="slider-container">
                                <Slider {...settings}>
                                    {
                                        productSliderList.map((product, index) => {
                                            return (
                                                <div key={index}>
                                                    <section className='home-slider-holder w-100'>
                                                        <div className="slider-desc1 gap-2 d-none d-lg-block">
                                                            {/* <p className='fs-md-14 fs-sm-12' data-aos="fade-right">{product.descriptionFirst}</p>
                                                            <p className='fs-md-14 fs-sm-12 m-0' data-aos="fade-right" data-aos-delay="150">{product.descriptionSecond}</p> */}
                                                            <h5 className='mb-3 fw-bold fs-18 align-items-center'><span className='mb-1 fs-23'><BiCheckShield /></span> Advantages</h5>
                                                            <ul className='fs-14 fs-md-14 fs-sm-12 d-grid gap-1 ps-3'>
                                                                <li><span className='fw-semibold'>Sustainable Materials:</span> Made from renewable and responsibly sourced paper to reduce environmental impact.</li>
                                                                <li><span className='fw-semibold'>Cost-Effective Solution:</span> Affordable without compromising quality, making them ideal for businesses of all sizes.</li>
                                                                <li><span className='fw-semibold'>Custom Branding Options:</span> Fully customizable with logos and designs to promote your brand effectively.</li>
                                                                <li><span className='fw-semibold'>Disposable and Hygienic:</span> Single-use design ensures hygiene, making them ideal for public spaces and events.</li>

                                                            </ul>
                                                        </div>
                                                        <div className="slider-image" data-aos="zoom-in" data-aos-delay="300">
                                                            <img src={product?.thumbnail} alt="" />
                                                        </div>
                                                        <div className="slider-desc2">
                                                            <div className='css-back-design d-grid  align-content-center'>
                                                                <span className='css-back-design-extra' />
                                                                <div className='sticky-img d-none d-sm-block d-lg-none d-xl-block' data-aos="zoom-in" data-aos-delay="150">
                                                                    <img src={product?.labelImage} alt="" />
                                                                </div>
                                                                <div className='d-grid align-content-center'>
                                                                    <div className='d-grid gap-3 text-center'>
                                                                        <h5 className='fs-25 fs-sm-20 fw-semibold m-0' data-aos="fade-left">{product.title}</h5>
                                                                        <p className='fs-md-14 fs-sm-12 m-0' data-aos="fade-left" data-aos-delay="150">{product.titleDescription}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </Col>
                    <Col className='col-12 text-center'>
                        <h2 className='fs-35 fs-md-25 fs-sm-20' style={{ fontFamily: "sans-serif" }}>0{activeSlide}/<span className='fs-25 fs-md-20 fs-sm-16'>{productSliderList?.length}</span> </h2>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ProductSlider